import React, { useCallback } from "react";

import { faRedo, faUndo } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSlate } from "slate-react";

import ToggleButton from "../ToggleButton";

import ActionTooltipWrapper from "./ActionTooltipWrapper";

interface HistoryControlProps {
  redo?: boolean;
}

const HistoryControl = ({ redo }: HistoryControlProps) => {
  const editor = useSlate();

  const handleAction = useCallback(() => {
    (redo ? editor.redo : editor.undo)();
  }, [editor, redo]);

  return (
    <ActionTooltipWrapper
      translationString={redo ? "ui.emailBody.toolbar.redo" : "ui.emailBody.toolbar.undo"}
    >
      <ToggleButton onClick={handleAction}>
        <FontAwesomeIcon icon={redo ? faRedo : faUndo} size="xs" />
      </ToggleButton>
    </ActionTooltipWrapper>
  );
};

export default HistoryControl;
